import { Store, AnyAction } from 'redux';

import type { AppState } from '@tmapy/redux';
import { configureStore as configureReduxStore, combineRootReducers } from '@tmapy/redux';
import { intlReducer } from '@tmapy/intl';

import { edas } from './reducer';

declare module '@tmapy/redux' {
  interface AppState {}
}

export function configureStore(): Store<AppState, AnyAction> {
  combineRootReducers({
    edas,
    intl: intlReducer,
  });

  const initialState = {};
  const store = configureReduxStore(initialState);

  return store;
}
